import * as React from 'react';
import { PersonaSize, IRenderFunction, IPersonaProps } from 'office-ui-fabric-react';
import { IListViewFieldColumn } from "../../../../../services/ViewService";
import { Resource } from '../../../../../store/ResourcesListStore';
import Link from '../../../../common/Link';
import { IWarning } from '../../../../../entities/common';
import EntityWarning from '../../../../common/warnings/EntityWarning';
import ImagePersona from '../../../../common/ImagePersona';

import { ApplicationState } from '../../../../../store';
import { connect } from 'react-redux';
import { UserState } from '../../../../../store/User';
import { canResourceAllRead } from '../../../../../store/permissions';

export default class Name extends React.Component<IListViewFieldColumn<Resource>> {
    public render() {
        const { name, imageId, id, warnings, isArchived } = this.props.entity;
        const { disableNavigation } = this.props;
        const canView = this.props.entity.isEditable || this.props.entity.canView;
        return <ResourceName name={name} imageId={imageId} href={!disableNavigation && !isArchived ? `/resource/${id}` : undefined} warnings={warnings} canView={canView} />;
    }
}

const renderPrimaryText: IRenderFunction<IPersonaProps> = (props?: IPersonaProps): JSX.Element => {
    return <span>{props ? props.text : ""}</span>;
};

type OwnProps = { name: string; imageId?: string; href?: string; warnings?: IWarning[], canView?: boolean, isInactive?: boolean };
type StateProps = { user: UserState };
const ResourceNameImpl = (props: OwnProps & StateProps) => {
    const { name, warnings, user, href, canView, imageId, isInactive } = props;
    const renderLink = !!href && (canResourceAllRead(user.permissions.resource) || canView);

    const persona = <ImagePersona
        size={PersonaSize.size32}
        imageId={imageId}
        text={name}
        onRenderPrimaryText={renderPrimaryText} />;

    const coin = isInactive
        ? <span className="inactive-persona">
            {persona}
            <span className="inactive-icon" />
        </span>
        : persona;

    return <div className={`${renderLink ? 'clickable' : ''} entityName overflow-text font-14 ${isInactive ? 'inactive' : ''}`}>
        {renderLink
            ? <Link href={href!} title={name} className="with-persona">{coin}</Link>
            : coin}
        {warnings && <EntityWarning warnings={warnings} />}
    </div>;
}

function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return { user: state.user }
}

export const ResourceName = connect(mapStateToProps)(ResourceNameImpl);
